import { Type } from "../models/message";

export interface StateInterface {
  visible: boolean;
  type: Type | "";
}

const state: StateInterface = {
  visible: false,
  type: ""
};

export default state;
